import type { Notification } from '../services/notificationService'

type Role = 'arborist' | 'client' | 'admin' | null | undefined

/**
 * Where a notification takes the user when tapped (008 R10 — the first deep
 * link the bell has had). Quotes go through the tiny `/quotes/:id` redirect
 * on the staff side so the notification schema needs no `job_id`; clients
 * land straight on the portal view. Unknown targets return null and the
 * row stays a plain mark-as-read button.
 */
export function routeForNotification(
  n: Pick<Notification, 'related_entity_type' | 'related_entity_id'>,
  role: Role
): string | null {
  if (!n.related_entity_id) return null
  const isClient = role === 'client'
  switch (n.related_entity_type) {
    case 'quote':
      return isClient ? `/portal/quotes/${n.related_entity_id}` : `/quotes/${n.related_entity_id}`
    case 'report':
      return isClient ? `/portal/reports/${n.related_entity_id}` : `/reports/${n.related_entity_id}`
    default:
      return null
  }
}
